import React, { useState, useEffect } from "react";
// import { Card, CardHeader, Container, Row } from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import AcademicModal from "models/academic.modal";
import { helper } from "lib/helper";
import VideoQueModal from "models/VideoQue.modal";

const EditVideoQuestionManagment = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const parmas = useParams();

  const getListData = async () => {
    setIsLoading(true);
    await AcademicModal.list(parameters)

      .then((result) => {
        // console.log("here", result);
        setIsLoading(false);
        if (result) {
          setIsLoading(false);
          setDataList(result?.data);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        // helper.sweetalert.toast(error.response?.data?.message, "warning");
        setIsLoading(false);
      });
  };

  console.log(dataList, "videodataList");
  useEffect(() => {
    getListData();
  }, [location]);

  const [databyidBoard, setDatabyidBoard] = useState([]);
  const [databyidClass, setDatabyidClass] = useState([]);
  const [databyidSubject, setDatabyidSubject] = useState([]);
  const [addsLoadig, setAddsLoadig] = useState(false);

  const [subjectId, setSubjectId] = useState("");

  const getListDataByid = async (id, name) => {
    console.log(id, "allid");
    setSubjectId(id);
    setIsLoading(true);
    await AcademicModal.listbyidAcademicSubCategory(id)
      .then((result) => {
        // console.log("here", result);
        setIsLoading(false);
        if (result) {
          if (name == "board") {
            setDatabyidBoard(result?.data?.data);
          }
          if (name == "class") {
            setDatabyidClass(result?.data?.data);
          }
          if (name == "subject") {
            setDatabyidSubject(result?.data?.data);
          }

          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("id", parmas?.id);
    form.append("catid", subjectId);
    // You can adjust the header configuration according to your API requirements
    VideoQueModal.editVideoQue(form)
      .then((response) => {
        helper.sweetalert.toast(
          "Your Video Questions Management update.",
          "success"
        );
        navigate(`/admin/videoquestionsmanagement`);

        setAddsLoadig(false);
        // getListData();
        // toggleModal();
        // Display success message to the user
      })
      .catch((error) => {
        setAddsLoadig(false);

        // helper.sweetalert.toast(
        //   error.response.data.message.catid[0],
        //   "warnig"
        // );
      });
  };

  const [videoIdData, setVideoIdData] = useState({});

  const getListDataByVideoQueid = () => {
    const data = parmas?.id;

    // Assuming '19' is the ID you want to send
    VideoQueModal.listbyVideoQuesid(data)
      .then((response) => {
        setVideoIdData(response.data.data);
        // console.log(response.data.data, "data");
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  useEffect(() => {
    if (parmas.id != "") {
      getListDataByVideoQueid();
    }
  }, []);

  const categoryData =
    videoIdData && videoIdData?.category?.map((item) => item.name);

  const categoryDataCatid =
    videoIdData && videoIdData?.category?.map((item) => item.catid);
  console.log(categoryDataCatid, "categoryDataCatid");

  useEffect(() => {
    if (videoIdData && categoryDataCatid && categoryDataCatid.length > 0) {
      getListDataByid(categoryDataCatid[categoryDataCatid.length - 1], "board");
    }
    if (videoIdData && categoryDataCatid && categoryDataCatid.length > 1) {
      getListDataByid(categoryDataCatid[categoryDataCatid.length - 2], "class");
    }
    if (videoIdData && categoryDataCatid && categoryDataCatid.length > 2) {
      getListDataByid(
        categoryDataCatid[categoryDataCatid.length - 3],
        "subject"
      );
    }
  }, [videoIdData]);

  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Edit Video Questions</h3>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Academic Type</Label>
                        <Input
                          id="forType"
                          name="type"
                          type="select"
                          onChange={(e) => {
                            getListDataByid(e.target.value, "board");
                            setDatabyidBoard([]);
                            setDatabyidClass([]);
                            setDatabyidSubject([]);
                          }}
                          // defaultValue={categoryDataCatid && categoryDataCatid.length > 0 ? categoryDataCatid[categoryDataCatid.length - 1] : ""}
                        >
                          <option value="">select option</option>
                          {dataList &&
                            categoryData &&
                            dataList?.map((item, index) => (
                              <option
                                key={index}
                                value={item.id}
                                selected={
                                  item?.id ===
                                  categoryDataCatid[
                                    categoryDataCatid.length - 1
                                  ]
                                }
                              >
                                {item.name}
                              </option>
                            ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label for="forType">Board</Label>
                        <Input
                          id="forType"
                          name="type"
                          type="select"
                          onChange={(e) => {
                            getListDataByid(e.target.value, "class");
                            setDatabyidClass([]);
                            setDatabyidSubject([]);
                          }}
                        >
                          <option value="">select option</option>
                          {databyidBoard &&
                            categoryData &&
                            databyidBoard?.map((item, index) => {
                              return (
                                <option
                                  key={index}
                                  value={item.id}
                                  // selected={item?.id === categoryDataCatid[2]}
                                  selected={
                                    item?.id ===
                                    categoryDataCatid[
                                      categoryDataCatid.length - 2
                                    ]
                                  }
                                >
                                  {item.name}
                                </option>
                              );
                            })}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="forType">Class</Label>
                        <Input
                          id="forType"
                          name="type"
                          type="select"
                          onChange={(e) => {
                            getListDataByid(e.target.value, "subject");
                            setDatabyidSubject([]);
                          }}
                        >
                          <option value="">select option</option>
                          {databyidClass &&
                            categoryData &&
                            databyidClass.map((item, index) => {
                              return (
                                <option
                                  value={item.id}
                                  // selected={item?.id === categoryDataCatid[1]}
                                  selected={
                                    item?.id ===
                                    categoryDataCatid[
                                      categoryDataCatid.length - 3
                                    ]
                                  }
                                >
                                  {item.name}
                                </option>
                              );
                            })}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label for="forType">Subject</Label>
                        <Input
                          id="forType"
                          name="type"
                          type="select"
                          onChange={(e) => setSubjectId(e.target.value)}
                        >
                          <option value="">select option</option>
                          {databyidSubject &&
                            categoryData &&
                            databyidSubject.map((item, index) => {
                              return (
                                <option
                                  value={item.id}
                                  selected={item?.id === categoryDataCatid[0]}
                                  key={index}
                                >
                                  {item.name}
                                </option>
                              );
                            })}
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 1</Label>
                        <Input
                          id="type"
                          name="question"
                          type="textarea"
                          placeholder="Enter Question"
                          defaultValue={videoIdData?.question}
                        />
                      </FormGroup>
                    </Col>

                    {/* <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 2</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                          // defaultValue={videoIdData?.question
                          // }
                        />
                      </FormGroup>
                    </Col> */}
                  </Row>
                  {/* <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 3</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 4</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 5</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 6</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 7</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 8</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 9</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 10</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 11</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 12</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 13</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 14</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 15</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 16</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 17</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 18</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 19</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Question 20</Label>
                        <Input
                          id="type"
                          // name="question"
                          type="textarea"
                          placeholder="Enter Question"
                        />
                      </FormGroup>
                    </Col>
                  </Row> */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      color="secondary"
                      to="/admin/videoquestionsmanagement"
                      tag={Link}
                    >
                      Cancel
                    </Button>
                    {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                    <Button
                      color="primary"
                      type="submit"
                      style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white",border:"none"}}
                    >
                      Save
                    </Button>
                    {/* )} */}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default EditVideoQuestionManagment;
